import { render, staticRenderFns } from "./contractLabel.vue?vue&type=template&id=66e54233&scoped=true&"
import script from "./contractLabel.vue?vue&type=script&lang=js&"
export * from "./contractLabel.vue?vue&type=script&lang=js&"
import style0 from "./contractLabel.vue?vue&type=style&index=0&id=66e54233&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e54233",
  null
  
)

export default component.exports